module.exports = __webpack_public_path__ + "img/Mask Group 164.5e11abf3.svg";